// extracted by mini-css-extract-plugin
module.exports = {"item":"Header_item__2VaIS","logo":"Header_logo__3T0lc","menu":"Header_menu__Zy7KP","notification":"Header_notification__20rrk","wrapper":"Header_wrapper__3tGRg"};